module.exports = __webpack_public_path__ + "img/nl.08b10c67.svg";